import React from 'react'
// export {};
import { useTranslation } from 'react-i18next';

const Greetings = () => {
    const {t} = useTranslation();
    let myDate = new Date();
    let hours = myDate.getHours();
    let greet;
    const theme = localStorage.getItem('Theme')

    if (hours < 12)
        greet = t('Morning');
    else if (hours >= 12 && hours <= 17)
        greet = t('Afternoon');
    else if (hours >= 17 && hours <= 24)
        greet = t('Evening');

    return <span className={theme === 'dark' ? 'Greet_label card_content' :'card_content'}>{t('Good')} {greet}</span>
}

export default Greetings 